import { render, staticRenderFns } from "./selfsceen.vue?vue&type=template&id=8778a58a&scoped=true&"
import script from "./selfsceen.vue?vue&type=script&lang=js&"
export * from "./selfsceen.vue?vue&type=script&lang=js&"
import style0 from "./selfsceen.vue?vue&type=style&index=0&id=8778a58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8778a58a",
  null
  
)

export default component.exports